import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AdaptiveLayoutService, AdaptiveLayoutState } from '@frontend/sports/layout/feature';
import { Store } from '@ngrx/store';
import { Observable, distinctUntilChanged } from 'rxjs';

import { UiManagerActions } from './ui-manager.actions';
import { UiManagerService } from './ui-manager.service';
import { IUiRootState, IUiState, uiStateSelector } from './ui-manager.state';
import { hasUiState } from './ui-state-helper';
import { UiStates } from './ui-states.enum';

@Component({
    selector: 'ms-ui-manager',
    template: '',
})
export class UiManagerComponent implements OnInit {
    private uiManagerService = inject(UiManagerService);
    private adaptiveLayoutService = inject(AdaptiveLayoutService);
    private store = inject<Store<IUiRootState>>(Store);

    uiState$: Observable<IUiState>;
    currentState: IUiState;
    private readonly destroyRef = inject(DestroyRef);

    constructor() {
        const store = this.store;

        this.uiState$ = store.select(uiStateSelector);
    }

    ngOnInit(): void {
        this.uiState$
            .pipe(
                distinctUntilChanged((prev, next) => {
                    return prev === next;
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((state) => {
                this.uiManagerService.updateUi(this.currentState, state);
                this.currentState = state;
            });
        this.adaptiveLayoutService.stateChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((next: AdaptiveLayoutState) => {
            this.updateUiStateFromAdaptiveLayout(next);
        });
    }

    private updateUiStateFromAdaptiveLayout(state: AdaptiveLayoutState): void {
        if (state.hasRightColumn && !hasUiState(this.currentState, UiStates.RightColumnVisible)) {
            this.store.dispatch(UiManagerActions.addState({ state: UiStates.RightColumnVisible }));
        }
        if (!state.hasRightColumn && hasUiState(this.currentState, UiStates.RightColumnVisible)) {
            this.store.dispatch(UiManagerActions.removeState({ state: UiStates.RightColumnVisible }));
        }
    }
}
